import React from 'react';
import Button from '../common/button/Button';
import svg404 from '../assets/svg/404.svg';

const volverPortalPrivado = () => {
  window.top.location.href = process.env.URL_PORTAL_PRIVADO;
};

export const Page404 = () => {
  return (
    <div className="container shadow">
      <div className="row mtop90">
        <div className="col-sm-10 offset-sm-1 ">
          <div className="row">
            <div className="col-12">
              <h1>PAGE 404</h1>
              <p>Esta sección se encuentra temporalmente fuera de servicio.</p>
              <br />
            </div>
            <div className="col-12">
              <img src={svg404} alt="svg404" />
            </div>
            <div className="col-sm-6">
              <Button
                buttonName="Volver al sitio privado"
                callFunction={volverPortalPrivado}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Page404;
